import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaExternalLinkAlt } from 'react-icons/fa';
import Hero from '../../components/Hero/Hero';
import heroBg from '../../assets/images/gallery/office/sales.jpg';
import './Contact.css';

const emails = [
  { address: 'sales@tokyobyokane.com.ph', label: 'Sales Inquiries' },
  { address: 'sales2@tokyobyokane.com.ph', label: 'Sales Inquiries (Alt)' },
  { address: 'admin@tokyobyokane.com.ph', label: 'General / Admin' },
];

const phones = [
  { number: '+63-49-508-7899', label: 'Main Line' },
  { number: '+63-49-508-7903', label: 'Line 2' },
  { number: '+63-49-508-7904', label: 'Line 3' },
];

const Contact = () => {
  return (
    <div className="contact-page">
      <Hero
        title={<>Contact <span className="highlight">Us</span></>}
        subtitle="Get in touch with us. We'd love to hear from you and will get back to you as soon as possible."
        backgroundImage={heroBg}
      />

      {/* Reach Us Section */}
      <section className="contact__reach section">
        <div className="container">
          <p className="section-subtitle">Reach Us Directly</p>
          <h2 className="section-title">How to <span className="highlight">Contact Us</span></h2>
          <p className="contact__desc">Click any email or phone number below to reach us directly. Our team responds within one business day.</p>

          <div className="contact__methods">
            {/* Email Card */}
            <div className="contact-method-card">
              <div className="contact-method-card__header">
                <div className="contact-method-card__icon"><FaEnvelope /></div>
                <h3>Email Us</h3>
              </div>
              <p className="contact-method-card__hint">Click to open your email client</p>
              <div className="contact-method-card__links">
                {emails.map((e, i) => (
                  <a key={i} href={`mailto:${e.address}`} className="contact-link">
                    <div className="contact-link__info">
                      <span className="contact-link__label">{e.label}</span>
                      <span className="contact-link__value">{e.address}</span>
                    </div>
                    <FaExternalLinkAlt className="contact-link__arrow" />
                  </a>
                ))}
              </div>
            </div>

            {/* Phone Card */}
            <div className="contact-method-card">
              <div className="contact-method-card__header">
                <div className="contact-method-card__icon"><FaPhoneAlt /></div>
                <h3>Call Us</h3>
              </div>
              <p className="contact-method-card__hint">Click to dial (mobile devices)</p>
              <div className="contact-method-card__links">
                {phones.map((p, i) => (
                  <a key={i} href={`tel:${p.number.replace(/-/g, '')}`} className="contact-link">
                    <div className="contact-link__info">
                      <span className="contact-link__label">{p.label}</span>
                      <span className="contact-link__value">{p.number}</span>
                    </div>
                    <FaExternalLinkAlt className="contact-link__arrow" />
                  </a>
                ))}
              </div>
            </div>

            {/* Address Card */}
            <div className="contact-method-card">
              <div className="contact-method-card__header">
                <div className="contact-method-card__icon"><FaMapMarkerAlt /></div>
                <h3>Visit Us</h3>
              </div>
              <p className="contact-method-card__hint">Click to open in Google Maps</p>
              <div className="contact-method-card__links">
                <a
                  href="https://maps.google.com/?q=Lot+C2-6B+Carmelray+Industrial+Park+2+Calamba+City+Laguna"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  <div className="contact-link__info">
                    <span className="contact-link__label">Office Address</span>
                    <span className="contact-link__value">Lot C2-6B Carmelray Industrial Park 2, Brgy. Punta, Calamba City, Laguna 4027</span>
                  </div>
                  <FaExternalLinkAlt className="contact-link__arrow" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="contact__map-section section">
        <div className="container">
          <p className="section-subtitle">Our Location</p>
          <h2 className="section-title">Find <span className="highlight">Us</span></h2>
          <div className="contact__map">
            <iframe
              title="Tokyo Byokane Philippines Location"
              src="https://maps.google.com/maps?q=Lot%20C2-6B%20Carmelray%20Industrial%20Park%202%2C%20Brgy.%20Punta%2C%20Calamba%20City%2C%20Laguna%204027&t=m&z=14&output=embed&iwloc=near"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              sandbox="allow-scripts allow-same-origin allow-popups"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
